// extracted by mini-css-extract-plugin
export default {"melodyVideo":"wO-z","isFullWidth":"xO-z","landingPageVideo":"yO-z","play":"zO-z","iframeVideo":"AO-z","playHidden":"BO-z","fullwidth":"CO-z"};